export function isSecondaryAccount() {
  const user = JSON.parse(localStorage.getItem('user') || 'null')
  return user?.account_type === 'Secondary'
}
